module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h4 class="center">Merge to <a href="/#person/'+
((__t=( mergeToPersonId ))==null?'':__t)+
'" target="_blank">'+
((__t=( mergeToPersonName ))==null?'':__t)+
'</a></h4>\r\n\r\n\r\n<div class="table-responsive well" style="font-size: 10px;">\r\n    <table class="table table-hover">\r\n        <thead>\r\n        <tr>\r\n            <th>System type</th>\r\n            <th>Name</th>\r\n            <th>Event</th>\r\n            <!--<th title="Diseases">Diseases</th>\r\n            <th>Form</th>-->\r\n            <th>Dose</th>\r\n            <th>Quant.</th>\r\n            <th>Freq.</th>\r\n            <th>Start date</th>\r\n            <th>Stop date</th>\r\n            <!--<th title="Documents">Docs</th>\r\n            <th>Comment</th>-->\r\n            <th></th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n        ';
 _.each(medications, function(medication, index) { 
__p+='\r\n\r\n        <tr ';
 if (!isMergedMedication(medication)) { 
__p+=' class="deprecated-header" ';
 } 
__p+=' >\r\n            <td>'+
((__t=( getSystemTypeName(medication.systemType) ))==null?'':__t)+
'</td>\r\n            <td>'+
((__t=( medication.name ))==null?'':__t)+
'</td>\r\n            <td>'+
((__t=( (medication.eventType || '').replace('_', ' ') ))==null?'':__t)+
'</td>\r\n            <!--<td class="center"><span class="clickable center show-diseases" id="'+
((__t=( medication.medicationUuid + '_diseases' ))==null?'':__t)+
'" title="Show diseases">...</span></td>\r\n            <td>'+
((__t=( medication.form ))==null?'':__t)+
'</td>-->\r\n            <td>'+
((__t=( medication.dose ))==null?'':__t)+
'</td>\r\n            <td>'+
((__t=( medication.quantity ))==null?'':__t)+
'</td>\r\n            <td>'+
((__t=( medication.frequency ))==null?'':__t)+
'</td>\r\n            <td>'+
((__t=( formatDate(medication.startDate) ))==null?'':__t)+
'</td>\r\n            <td>'+
((__t=( formatDate(medication.stopDate) ))==null?'':__t)+
'</td>\r\n            <!--<td class="center"><span class="clickable center show-docs" id="'+
((__t=( medication.medicationUuid + '_docs' ))==null?'':__t)+
'" title="Show documents">...</span></td>\r\n            <td class="center"><span class="clickable center show-comment" id="'+
((__t=( medication.medicationUuid + '__' ))==null?'':__t)+
'" title="Show comment">...</span></td>-->\r\n            <td><span class="control-label glyphicon glyphicon-remove-circle clickable remove" id="'+
((__t=( medication.medicationUuid ))==null?'':__t)+
'" title="Remove"></span></td>\r\n        </tr>\r\n\r\n        ';
 }) 
__p+='\r\n        </tbody>\r\n    </table>\r\n</div>\r\n\r\n<div id="inner-show"></div>\r\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/persons/merge-to-person-medications-view.html
// module id = 493
// module chunks = 0